import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { localStorageHelper } from 'src/services';
import { typeUser } from '@monorepo/models';
import { unauthenticatedConfig, unauthenticatedUser } from '@monorepo/helpers';

const userSlice = createSlice({
    name: 'user',
    initialState: localStorageHelper.GetUser() ?? unauthenticatedUser,
    reducers: {
        logoutReducer: (state) => {
            localStorageHelper.RemoveAuthToken();
            localStorageHelper.SetUser(unauthenticatedUser);
            localStorageHelper.SetConfig(unauthenticatedConfig);
            state = unauthenticatedUser;
            return state;
        },
        refreshUserReducer: (state, action: PayloadAction<typeUser>) => {
            localStorageHelper.SetUser(action.payload);
            state = action.payload;
            return state;
        }
    }
});

export const userReducer = userSlice.reducer;

export const { logoutReducer, refreshUserReducer } = userSlice.actions;
